import Vue from 'vue';
import textResource from '../lib/resources/textResource';
const BeginningOfReferenceRegex = /^@:/;

// This method traverses a JSON object graph using a key recursively:
// for eg. obj = { a: { b: '1' } }; when key is 'a.b', '1' is returned.
// In the case where the eventual value is key (a reference to another value),
// then the whole process starts over again.
// See /text-resource.test.ts for more detail.
function lookUp(originalObject, currentObject, key): string | null {
  if (currentObject == null) return null;
  if (key.length === 0) {
    const objectAsString = currentObject.toString();

    if (BeginningOfReferenceRegex.test(objectAsString)) {
      return lookUp(
        originalObject,
        originalObject,
        objectAsString.replace(BeginningOfReferenceRegex, '').split('.')
      );
    } else {
      return objectAsString;
    }
  }

  const [head, ...tail] = key;
  return lookUp(originalObject, currentObject[head], tail);
}

export const t = (key: string): string | null => {
  return lookUp(textResource, textResource, key.split('.'));
};

// Usage in template:
// {{ 'show.some.copy' | t }}
Vue.filter('t', t);

// Usage anywhere:
// this.$t('show.some.copy')
Vue.use({
  install(Vue) {
    Vue.prototype.$t = t;
  }
});
